<template lang="pug">
BriqLayout(
  :boldLinks="boldLinks"
  :normalLinks="normalLinks"
  )
  router-view
  BriqEnvironment
  BriqIconDefs
  NotificationContainer
  RefreshApiTokenDialog
</template>

<script>
export default {
  name: 'BriqRoot',
  data() {
    return {
      boldLinks: [
        { name: 'Planboard', path: '/planboard' },
        { name: 'Bookings', path: '/bookings' },
        { name: 'Dashboard', path: '/dashboard' },
      ],
      normalLinks: [
        { name: 'Schedule', path: '/schedule' },
        { name: 'Customers', path: '/customers' },
        { name: 'Products', path: '/products' },
        { name: 'Payments', path: '/payments' },
        { name: 'Reports', path: '/reports' },
        { name: 'Settings', path: '/settings/application/main' },
      ],
    }
  },
}
</script>

<style lang="stylus">
body
  font-family 'Roboto', sans-serif
  font-size 16px
  color #2c333a
  -webkit-font-smoothing antialiased
</style>
